import { Chassis } from '../../scene/Chassis';
import { useBodyPalette } from '../../scene/BodyFinish';
import { GLASS, HEADLIGHT, TAIL_LIGHT } from '../../scene/materials';

const RigidHaulTruckBody = () => {
  const palette = useBodyPalette('rigid_haul_truck');
  return <group>
    <Chassis>
      <mesh position={[-0.35, 1.02, 0]}>
        <boxGeometry args={[6.9, 0.28, 0.28]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>
      {[-1, 1].map((side) => <mesh key={`rail-${side}`} position={[-0.35, 1.15, side * 0.92]}>
        <boxGeometry args={[6.9, 0.22, 0.16]} />
        <meshPhysicalMaterial {...palette.chassis} />
      </mesh>)}
    </Chassis>

    <mesh position={[2.35, 1.82, 0]}>
      <boxGeometry args={[1.55, 1.78, 2.5]} />
      <meshPhysicalMaterial {...palette.body} />
    </mesh>
    <mesh position={[3.17, 2.18, 0]}>
      <boxGeometry args={[0.05, 0.56, 1.82]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`side-window-${side}`} position={[2.45, 2.2, side * 1.263]}>
      <boxGeometry args={[0.82, 0.52, 0.025]} />
      <meshPhysicalMaterial {...GLASS} />
    </mesh>)}
    <mesh position={[3.23, 1.18, 0]}>
      <boxGeometry args={[0.16, 0.34, 2.65]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`headlight-${side}`} position={[3.28, 1.42, side * 0.78]}>
      <boxGeometry args={[0.08, 0.2, 0.34]} />
      <meshPhysicalMaterial {...HEADLIGHT} />
    </mesh>)}

    <mesh position={[-1.02, 1.72, 0]} rotation={[0, 0, -0.03]}>
      <boxGeometry args={[4.45, 1.35, 2.62]} />
      <meshPhysicalMaterial {...palette.secondary} />
    </mesh>
    <mesh position={[-3.25, 1.95, 0]} rotation={[0, 0, -0.13]}>
      <boxGeometry args={[0.18, 1.72, 2.66]} />
      <meshPhysicalMaterial {...palette.secondary} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`bed-rail-${side}`} position={[-1.05, 2.42, side * 1.32]}>
      <boxGeometry args={[4.3, 0.1, 0.08]} />
      <meshPhysicalMaterial {...palette.edge} />
    </mesh>)}
    <mesh position={[0.9, 1.38, 0]}>
      <boxGeometry args={[0.18, 0.22, 2.3]} />
      <meshPhysicalMaterial {...palette.chassis} />
    </mesh>
    {[-1, 1].map((side) => <mesh key={`tail-light-${side}`} position={[-3.36, 1.08, side * 0.98]}>
      <boxGeometry args={[0.08, 0.2, 0.28]} />
      <meshPhysicalMaterial {...TAIL_LIGHT} />
    </mesh>)}
  </group>;
};

export { RigidHaulTruckBody };
